<template>
  <p>In 2018, two VIZBI Showcase events took place:</p>
  <ShowcaseEventList year="2018" />
</template>

<script setup>
import ShowcaseEventList from "@/components/ShowcaseEventList.vue";
</script>
